import useUserPermissions from 'hooks/useUserPermissions';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export const AdminOnlyRoute = () => {
    const { isAdmin } = useUserPermissions();

    if (!isAdmin) {
        return <Navigate to={`/${window.location.search}`} replace />;
    }

    return <Outlet />;
};
